const img = require('./puff-geosecma-nyhetsbrev_13266697e0ef459b2621e346164c6de2.png').default; export default img;